import { useQuery } from '@apollo/client';
import classNames from 'classnames';
import React from 'react';
import getFeature from '../../utils/features';
import Button from '../../components/Button';
import Card, { Cards } from '../../components/Card';
import SVGIcon from '../../components/SVGIcon';
import { PlanTier } from '../../graphql/generated/graphql';
import webhookIcon from '../../icons/non-prefilled/16x16/webhook.svg';
import SettingsSection from '../../settings/SettingsSection';
import SettingsSectionUpsell from '../../settings/SettingsSectionUpsell';
import * as styles from './AdminWebhooksView.module.scss';
import { gql } from '../../graphql/generated/gql';
import Link from '../../utils/router/Link';

export const ALL_WEBHOOKS_QUERY = gql(`
  query allWebhooks {
    session: currentSession {
      organization {
        id
        webhooks {
          id
          name
          targetUrl
        }
      }
    }
  }
`);

const AdminWebhooksView = () => {
  const isWebhooksEnabled = getFeature('webhook');

  const { data } = useQuery(ALL_WEBHOOKS_QUERY, { skip: !isWebhooksEnabled });

  const webhooks = data?.session.organization.webhooks ?? [];

  if (!isWebhooksEnabled) {
    return (
      <SettingsSectionUpsell
        header="Webhooks"
        feature="webhooks"
        description="Upgrade to set up webhooks to get notified of events occuring in Slab."
        minTier={PlanTier.Business}
        contentCards={
          <Card noPadding>
            <div className={styles.webhookCard}>
              <SVGIcon className={styles.webhookCardIcon} size={24}>
                {webhookIcon}
              </SVGIcon>
              <div className={styles.webhookCardTitle}>My Webhook</div>
              <div className={styles.webhookCardSubtitle}>
                https://hooks.myhook.com/hooks/catch/2476169/ok1flx7/
              </div>
            </div>
          </Card>
        }
      />
    );
  }

  return (
    <SettingsSection
      header="Webhooks"
      subheader="Notify external services when content is modified in Slab."
    >
      {webhooks.length > 0 && (
        <Cards>
          {webhooks.map((webhook, index) => (
            <Card key={webhook.id || index} noPadding>
              <div
                className={classNames(
                  styles.webhookCard,
                  styles.webhookCardWithButton,
                )}
              >
                <SVGIcon className={styles.webhookCardIcon} size={24}>
                  {webhookIcon}
                </SVGIcon>
                <div className={styles.webhookCardTitle}>{webhook.name}</div>
                <div className={styles.webhookCardSubtitle}>
                  {webhook.targetUrl}
                </div>
                <Button
                  className={styles.webhookCardButton}
                  variant="secondary"
                  to={`/admin/developer/webhooks/${webhook.id}`}
                >
                  Edit
                </Button>
              </div>
            </Card>
          ))}
        </Cards>
      )}
      <div className={styles.webhookButtons}>
        <Button to="/admin/developer/webhooks/new" variant="primary">
          Add new
        </Button>
        <Link
          to="https://go.slab.com/webhook-reference"
          rel="noopener noreferrer"
          target="_blank"
        >
          Webhooks Reference
        </Link>
      </div>
    </SettingsSection>
  );
};

export default AdminWebhooksView;
